import { stringify as stringifyQs } from "qs";
import urljoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  TabActionDialog
} from "../types";

const AnnouncementsSection = "/announcements/";

export const AnnouncementsListPath = AnnouncementsSection;

export enum AnnouncementListUrlFiltersEnum {
  status = "status",
  startedFrom = "startedFrom",
  startedTo = "startedTo",
  query = "query"
}
export type AnnouncementListUrlFilters = Filters<
  AnnouncementListUrlFiltersEnum
>;
export type AnnouncementListUrlDialog =
  | "assign-status"
  | "deactivate"
  | "delete"
  | TabActionDialog;
export type AnnouncementListUrlQueryParams = ActiveTab &
  BulkAction &
  AnnouncementListUrlFilters &
  Dialog<AnnouncementListUrlDialog> &
  Pagination;

export const announcementListUrl = (params?: AnnouncementListUrlQueryParams) =>
  AnnouncementsSection + "?" + stringifyQs(params);

export const announcementAddPath = urljoin(AnnouncementsSection, "add");
export const announcementAddUrl = () => announcementAddPath;
export const announcementPath = (id: string) =>
  urljoin(AnnouncementsSection, id);
export type AnnouncementUrlDialog = "delete";
export type AnnouncementUrlQueryParams = Dialog<AnnouncementUrlDialog>;
export const announcementUrl = (
  id: string,
  params?: AnnouncementUrlQueryParams
) => announcementPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
